import { render, staticRenderFns } from "./inbound-call-answered-icon.vue?vue&type=template&id=aef1b8e8"
import script from "./inbound-call-answered-icon.vue?vue&type=script&lang=js"
export * from "./inbound-call-answered-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aef1b8e8')) {
      api.createRecord('aef1b8e8', component.options)
    } else {
      api.reload('aef1b8e8', component.options)
    }
    module.hot.accept("./inbound-call-answered-icon.vue?vue&type=template&id=aef1b8e8", function () {
      api.rerender('aef1b8e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/contact-activity/inbound-call-answered-icon.vue"
export default component.exports